/* src/XertTheme.svelte generated by Svelte v4.2.20 */
import { SvelteComponent, init, safe_not_equal } from "svelte/internal";

import "svelte/internal/disclose-version";

class XertTheme extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, null, safe_not_equal, {});
	}
}

export default XertTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwic291cmNlcyI6WyJYZXJ0VGhlbWUuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzdHlsZSBnbG9iYWwgbGFuZz1cInNjc3NcIj5cbiAgQGltcG9ydCAnLi9zdHlsZS94ZXJ0LnNjc3MnO1xuPC9zdHlsZT5cbiJdfQ==
import "/home/forge/alpha/svelte-components/src/XertTheme.esbuild-svelte-fake-css";